module.exports = __webpack_public_path__ + "va.8aae3709fb23884b7c01.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/4x3/va.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/4x3/va.svg
// module chunks = styles